import React, { useContext, useState, useEffect } from 'react';
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import GroupButtonsForm from '../helpers_components/GroupSubmitFormButtons';
import { resendConfirmationEmail, initForm } from './forgot_password_logic';
import Plain from '../layout/containers/Plain';
import LoaderContext from '../layout/shared/loader_context';
import { backgroundImageStyles } from '../../inLineStyles/backgroundImageStyles/backgroundImageStyles';
import { NotificationManager } from 'react-notifications';
const ResendConfirmEmail = (props) => {
  const [form, setForm] = useState(initForm);
  const Loader = useContext(LoaderContext);
  const [tries, setTries] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [bottonDisabled, setButtonDisabled] = useState(false);

  const onChangeEventHandler = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    Loader.show(true);
    setTries(tries + 1);
    await resendConfirmationEmail(
      form,
      props,
      timerActive,
      setTimerActive,
      setTimeLeft,
      setButtonDisabled
    );
    Loader.show(false);
  };

  useEffect(() => {
    let timer;
    if (tries >= 3) {
      NotificationManager.warning(
        'Has alcanzado el número máximo de intentos, espere 1 hora para volver a intentarlo.'
      );
      timer = setTimeout(() => {
        setTries(0);
      }, 3600000);
    }

    return () => clearTimeout(timer);
  }, [tries]);

  useEffect(() => {
    let interval;
    if (timerActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            setTimerActive(false);
            setButtonDisabled(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timerActive, timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes} minuto${minutes !== 1 ? 's' : ''} y ${secs} segundo${secs !== 1 ? 's' : ''}`;
  };

  return (
    <Plain {...props} noHeader={true} noFooter={true}>
      <Container
        fluid={true}
        className="min-height-100vh bg-size-cover"
        style={backgroundImageStyles}
      >
        <Container>
          <Row style={{ minHeight: '100vh' }}>
            <Col
              sm={12}
              md={{ span: 10, offset: 1 }}
              lg={{ span: 8, offset: 2 }}
              xl={{ span: 6, offset: 3 }}
              className="mY-30"
            >
              <Card className="mY-40@sm+">
                <Card.Header>
                  <Container>
                    <Row>
                      <Col
                        xs={12}
                        md={{ span: 10, offset: 1 }}
                        className="pT-20 pB-10 pT-30@sm+ pB-20@sm+"
                      >
                        <h3 className="mb-0 text-center">Reenviar correo de confirmación</h3>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body>
                  <Container>
                    <Row>
                      <Col xs={12} md={{ span: 10, offset: 1 }} className="pT-30">
                        <p className="mB-30 text-justify">
                          Ingresa el correo electrónico con el que te registraste y te enviaremos un
                          nuevo correo de confirmación.
                        </p>

                        <Form onSubmit={(e) => onSubmitHandler(e)}>
                          <Form.Group controlId="formBasicEmail">
                            <Form.Label className="font-weight-bold">* Email</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Correo Electronico"
                              autoFocus
                              onChange={onChangeEventHandler}
                              name="email"
                            />
                          </Form.Group>

                          <div className="pY-20">
                            <GroupButtonsForm
                              primaryText="Continuar"
                              secondaryText="Cancelar"
                              disabled={form.email === '' || tries >= 3 || bottonDisabled}
                            />
                            {timerActive && timeLeft > 0 && (
                              <div
                                className="text-center mt-3"
                                style={{ color: '#dc3545', fontWeight: 'bold' }}
                              >
                                Próximo intento en: {formatTime(timeLeft)}
                              </div>
                            )}
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
    </Plain>
  );
};

export default ResendConfirmEmail;
